<template>
    <v-btn :disabled="!deveHabilitarBotoes" outline color="primary" @click.stop="$emit('assinarDocumentosEmLote')">
        <v-icon left size="15">fas fa-signature</v-icon>
        Assinar
    </v-btn>
</template>

<script>
export default {
    name: 'BotaoAssinarDocumentoEmLote',
    props:['deveHabilitarBotoes']
}
</script>

<style scoped lang="stylus">

</style>